module.exports = __webpack_public_path__ + "img/knu_detail.717d6ae0.jpg";